import PropTypes from 'prop-types';

import useStepperState from '../hooks/useStepperState';

import Gate from './Gate';

const StepperProgress = ({ disableNav }) => {
  const { currentGate, currentStep, gates, steps } = useStepperState();
  const gateList = [...gates.values()];
  const gateElements = gateList.map((gate, idx) => (
    <Gate
      ariaPosinset={idx + 1}
      ariaSetsize={gateList.length}
      currentStep={currentStep}
      disableNav={disableNav}
      gate={gate}
      gateTotal={gates.size}
      isActive={idx === currentGate}
      key={gate.id}
      steps={steps}
    />
  ));

  return (
    <ol className="flex items-center content-center justify-around list-none mx-8 mt-16 mb-20 px-4 py-0">
      {gateElements}
    </ol>
  );
};

StepperProgress.propTypes = {
  disableNav: PropTypes.bool,
};

StepperProgress.defaultProps = {
  disableNav: false,
};

export default StepperProgress;
